/**
 * DocumentsTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const DocumentsTab = ({ ctx }) => {
  const {
    formData,
    handleDocChange,
  } = ctx;

  return (
          <TabsContent value="documents">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <FileText className="w-5 h-5 text-stone-700" />
                  Identification Documents
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Document Type</Label>
                    <select
                      value={formData.identification_documents[0]?.document_type}
                      onChange={(e) => handleDocChange(0, 'document_type', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="">Select</option>
                      <option value="Passport">Passport</option>
                      <option value="National ID">National ID (Aadhaar)</option>
                      <option value="PAN Card">PAN Card</option>
                      <option value="Driver License">Driver License</option>
                      <option value="Voter ID">Voter ID</option>
                    </select>
                  </div>
                  <div>
                    <Label>Document Number</Label>
                    <Input
                      value={formData.identification_documents[0]?.document_number}
                      onChange={(e) => handleDocChange(0, 'document_number', e.target.value.toUpperCase())}
                      placeholder="XXXXXXXXXXXX"
                    />
                  </div>
                  <div>
                    <Label>Issue Date</Label>
                    <Input
                      type="date"
                      value={formData.identification_documents[0]?.issue_date}
                      onChange={(e) => handleDocChange(0, 'issue_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Expiry Date</Label>
                    <Input
                      type="date"
                      value={formData.identification_documents[0]?.expiry_date}
                      onChange={(e) => handleDocChange(0, 'expiry_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Issuing Authority</Label>
                    <Input
                      value={formData.identification_documents[0]?.issuing_authority}
                      onChange={(e) => handleDocChange(0, 'issuing_authority', e.target.value)}
                      placeholder="Government of India"
                    />
                  </div>
                  <div>
                    <Label>Issuing Country</Label>
                    <Input
                      value={formData.identification_documents[0]?.issuing_country}
                      onChange={(e) => handleDocChange(0, 'issuing_country', e.target.value)}
                      placeholder="India"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default DocumentsTab;
